import { MediaDevices } from "./media-devices-utils";

export function videoStreamUrlForClient(clientId, source = null) {
  const sourceQuery = source ? `?source=${encodeURIComponent(source)}` : "";

  return `hubs://clients/${clientId}/video${sourceQuery}`;
}

export function getClientIdFromVideoStreamUrl(src) {
  return src?.substring(7).split("/")[1] || "";
}

export function getVideoSourceFromVideoStreamUrl(src) {
  const queryString = src?.split("?")[1] || "";
  const source = new URLSearchParams(queryString).get("source");

  return source === MediaDevices.CAMERA || source === MediaDevices.SCREEN ? source : null;
}
